import Vue from 'vue'
import Router from 'vue-router'
import Index from '../pages/index.vue'
import Home from '../pages/home.vue'

Vue.use(Router)


const router = new Router({
  mode: 'history',
  linkActiveClass: 'on',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      redirect: '/home',
      children: [{
        path: '/home',
        name: 'Home',
        component: Home
      },
      {
        path: '/lecturerCourse',
        name: 'LecturerCourse',
        component: resolve => (require(["../pages/lecturerCourse.vue"], resolve)),
      },
      {
        path: '/curriculumCenter',
        name: 'curriculumCenter',
        component: resolve => (require(["../pages/curriculumCenter.vue"], resolve)),
      }, {
        path: '/notice',
        name: 'noticeList',
        component: resolve => (require(["../pages/notice.vue"], resolve))
      },
      {
        path: '/noticeDetail',
        name: 'noticeDetail',
        component: resolve => (require(["../pages/noticeDetail.vue"], resolve)),
      }, {
        path: '/parentsChannel',
        name: 'parentsChannel',
        component: resolve => (require(["../pages/parentsChannel.vue"], resolve)),
      }, {
        path: '/teacherCurriculum/:user',
        name: 'teacherCurriculum',
        component: resolve => (require(["../pages/teacherCurriculum.vue"], resolve)),
      }, {
        path: '/searchPage',
        name: 'searchPage',
        component: resolve => (require(["../pages/searchPage.vue"], resolve)),
      }, {
        path: '/myShop',
        name: 'myShop',
        component: resolve => (require(["../pages/myShop.vue"], resolve)),
        redirect: '/myShop/basMessage',
        children: [
          // 基础信息
          {
            path: '/myShop/basMessage',
            name: 'basMessage',
            component: resolve => (require(["../pages/basMessage.vue"], resolve)),
          },
          // 修改密码
          {
            path: '/myShop/editPsw',
            name: 'editPsw',
            component: resolve => (require(["../pages/editPsw.vue"], resolve)),
          },
          // 购物车
          {
            path: '/myShop/shoppingCart',
            name: 'shoppingCart',
            component: resolve => (require(["../pages/shoppingCart.vue"], resolve)),
          },
          // 我的课程
          {
            path: '/myShop/myCurriculum',
            name: 'myCurriculum',
            component: resolve => (require(["../pages/myCurriculum.vue"], resolve)),
          },
          // 我的订单
          {
            path: '/myShop/myOrder',
            name: 'myOrder',
            component: resolve => (require(["../pages/myOrder.vue"], resolve)),
          },
          // 意见反馈
          {
            path: '/myShop/feedback',
            name: 'feedback',
            component: resolve => (require(["../pages/feedback.vue"], resolve)),
          }
        ]
      }, {
        path: '/purchaseDetails/:id/:type',
        name: 'purchaseDetails',
        component: resolve => (require(["../pages/purchaseDetails.vue"], resolve)),
      }, {
        path: '/watchCourse/:id/:type',
        name: 'watchCourse',
        component: resolve => (require(["../pages/watchCourse.vue"], resolve)),
      },
      {
        path: '/forget',
        name: 'forget',
        component: resolve => (require(["../pages/forget.vue"], resolve)),
      }, {
        path: '/purchase',
        name: 'purchase',
        component: resolve => (require(["../pages/purchase.vue"], resolve)),
      }, {
        path: '/success',
        name: 'success',
        component: resolve => (require(["../pages/success.vue"], resolve)),
      }, {
        path: '/fail',
        name: 'fail',
        component: resolve => (require(["../pages/fail.vue"], resolve)),
      }, {
        path: '/about',
        name: 'about',
        component: resolve => (require(["../pages/about.vue"], resolve)),
      }, {
        path: '/agreement',
        name: 'agreement',
        component: resolve => (require(["../pages/agreement.vue"], resolve)),
      }]
    }
    , {
      path: '/alipayPayPage',
      name: 'alipayPayPage',
      component: resolve => (require(["../pages/alipayPayPage.vue"], resolve)),
    }, {
      path: '/paymentCompleted',
      name: 'paymentCompleted',
      component: resolve => (require(["../pages/paymentCompleted.vue"], resolve)),
    }
  ]
})
router.beforeEach((to, from, next) => {
  if(from.name=="purchaseDetails"||from.name=="watchCourse"){
    document.title = "331教育";
  }
  document.documentElement.scrollTop = 0
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js